import React, { useEffect } from 'react';
import "./Timeline.css";

const Timeline = () => {

  useEffect(() => {
    const timelineItems = document.querySelectorAll('.timeline-item');

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated', 'fadeInLeft'); // Add fadeInLeft animation class
          observer.unobserve(entry.target); // Stop observing once animated
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0.5
    });

    timelineItems.forEach(item => {
      observer.observe(item);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section className='mission-vision-goal'>
    <div className="container">
      <h2 className="text-left timline-h2">Our Core <span>Beliefs</span></h2>
      <p className="our-core-paragraph">We are committed to delivering quality services to our customers. Our core Beliefs are:</p>
      <ul className="timeline">
        <li className="timeline-item">
          <div className="timeline-badge danger"><i className="fa-solid fa-bullseye fa-beat"></i></div> 
          <div className="timeline-panel">
            <div className="timeline-heading">
              <h4 className="timeline-title">Our <span>Mission</span></h4>
            </div>
            <div className="timeline-body">
              <p>Maximize your ROI with our Teamcenter implementation, achieving excellence and customer satisfaction through world-class PLM solutions. We drive your PLM vision forward with collaborative and advanced strategies. </p>
            </div>
          </div>
        </li>
        <li className="timeline-item timeline-inverted">
          <div className="timeline-badge warning"><i className="fa-solid fa-eye fa-beat"></i></div>
          <div className="timeline-panel">
            <div className="timeline-heading">
              <h4 className="timeline-title">Our <span> Vision</span></h4>
            </div>
            <div className="timeline-body">
             
              <p>Maximize your ROI with our Teamcenter implementation, achieving excellence and customer satisfaction through world-class PLM solutions. We drive your PLM vision forward with collaborative and advanced strategies. </p>
           
            </div>
          </div>
        </li>
        <li className="timeline-item">
          <div className="timeline-badge danger"><i className="fa-solid fa-heart fa-beat"></i></div>
          <div className="timeline-panel">
            <div className="timeline-heading">
              <h4 className="timeline-title">Our <span>Values</span></h4>
            </div>
            <div className="timeline-body">
              <p>At the heart of our values lies a commitment to being a trusted technology partner for our customers. We believe in being real and ethical, fostering true collaboration, and showing mutual respect for everyone we work with. We are dedicated to creating equal opportunities for all our stakeholders, ensuring a fair and inclusive environment. </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    </section>
  );
}

export default Timeline;